import { useParams } from "react-router-dom";
import { useStateContext } from "state";
import { useAccountQuicksight } from "../../hooks/quicksight/useAccountQuicksight.ts";
import { DashboardZeroState } from "./dashboard-zero-state.tsx";
import { IFrame } from "core/components/iframe/index.ts";
import { DashboardError } from "./dashboard-error.tsx";

interface IDashboardProps {
  contextId: string;
}

export function Dashboard({ contextId }: IDashboardProps) {
  const { user } = useStateContext();
  const { id } = useParams();

  // we have two paths here but, only one is provided in the route when there are multiple accounts
  const accountNumber = user?.isSingleAdHocAccount
    ? user.roles[0].accountNumber
    : id!;

  const result = useAccountQuicksight({
    account_number: accountNumber,
    context_id: contextId,
  });

  if (!result.isLoading && !result.error && !result.data)
    return <DashboardZeroState />;

  return (
    <IFrame.Query
      query={result}
      renderError={(err) => <DashboardError />}
    />
  );
}
